const WorkBgThree = () => {
  return (
    <div className="work_bg3 bg_img">
      <svg
        width="165"
        height="349"
        viewBox="0 0 165 349"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          className="bg"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M234.845 97.2275C244.626 107.734 258.983 111.778 268.875 122.18C281.077 135.01 298.821 146.955 298.953 164.638C299.085 182.272 279.448 192.713 269.512 207.274C259.535 221.896 253.338 238.3 240.423 250.41C222.493 267.223 203.914 298.297 180.476 290.762C155.541 282.747 161.731 243.372 148.417 220.833C140.066 206.696 125.085 198.37 117.347 183.89C107.799 166.021 96.0022 147.504 98.5007 127.419C101.149 106.128 116.003 88.6999 131.087 73.4426C147.513 56.8277 165.949 30.8949 188.759 36.1236C214.147 41.9434 217.099 78.1664 234.845 97.2275Z"
        />
        <path
          className="line"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M219.742 95.921C231.059 108.077 247.672 112.757 259.118 124.793C273.237 139.639 293.768 153.461 293.922 173.922C294.074 194.326 271.353 206.408 259.855 223.256C248.31 240.174 241.14 259.156 226.196 273.169C205.449 292.623 183.952 328.579 156.831 319.86C127.98 310.585 135.141 265.025 119.736 238.945C110.074 222.587 92.7383 212.953 83.7855 196.198C72.7366 175.521 59.0871 154.096 61.9782 130.856C65.0428 106.22 82.2297 86.0538 99.6833 68.3996C118.69 49.1744 140.022 19.1676 166.416 25.2178C195.792 31.9518 199.209 73.8654 219.742 95.921Z"
          strokeWidth="2"
        />
      </svg>
    </div>
  );
};

export default WorkBgThree;
